import ColorSchemeForm from '@/components/sections/builder/theme/color/scheme-form';
import ThemeColorPreview from '@/components/sections/builder/theme/color/scheme-preview';
import { ThemeColorSchemeType, ThemeColorType, useBuilderStore } from '@/stores/builder';
import { PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_COLOR_SCHEME: ThemeColorSchemeType = {
  id: 1,
  background: '#FFFFFF',
  text: '#121212',
  textSecondary: '#121212',
  btnSolidBackgroud: '#121212',
  btnSolidlabel: '#FFFFFF',
  btnOutline: '#121212',
  shadow: '#121212',
  imageBackground: '#ffffff',
};

export const DEFAULT_THEME_COLOR: ThemeColorType = {
  colorSchemes: [DEFAULT_THEME_COLOR_SCHEME],
};

export default function ThemeColorSetting() {
  const [selectedScheme, setSelectedScheme] = useState<ThemeColorSchemeType>();

  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const color = builder.theme?.color || DEFAULT_THEME_COLOR;
  const colorSchemes = color.colorSchemes || [];

  const setColor = (value: Partial<ThemeColorType>) => {
    builder.setTheme({
      color: { ...color, ...value },
    });
  };

  const onChangeScheme = (scheme: Partial<ThemeColorSchemeType>) => {
    setColor({
      colorSchemes: colorSchemes.map((v) => (v.id === scheme.id ? { ...v, ...scheme } : v)),
    });
  };

  const onAddScheme = () => {
    const id = Math.max(...[...colorSchemes.map((v) => v.id as number), 0]) + 1;
    const scheme = {
      ...DEFAULT_THEME_COLOR_SCHEME,
      id,
    };

    setColor({
      colorSchemes: [...colorSchemes, scheme],
    });
    setSelectedScheme(scheme);
  };

  const onClose = (id?: number) => {
    if (id) {
      setColor({
        colorSchemes: colorSchemes.filter((v) => v.id !== id),
      });
    }

    setSelectedScheme(undefined);
  };

  return (
    <div>
      {selectedScheme ? (
        <ColorSchemeForm
          scheme={selectedScheme}
          cancelChoice={setSelectedScheme}
          onChange={onChangeScheme}
          onClose={onClose}
        />
      ) : (
        <>
          <div className='font-bold'>Schemes</div>
          <div className='mt-1 text-xs'>
            Color schemes can be applied to sections throughout your online store.
          </div>
          <div className='mt-4 grid grid-cols-2 gap-4'>
            {colorSchemes?.map((scheme) => (
              <button type='button' onClick={() => setSelectedScheme(scheme)} key={scheme.id}>
                <div className='rounded-md border duration-300 hover:border-primary'>
                  <ThemeColorPreview scheme={scheme} />
                </div>
                <div className='mt-2 text-xs'>Scheme {scheme.id}</div>
              </button>
            ))}
            <button type='button' onClick={onAddScheme}>
              <div className=''>
                <div className='flex flex-col items-center justify-center rounded-md border  border-dashed border-primary px-3 py-[22px]'>
                  <PlusIcon className='h-4 w-4 text-primary' />
                </div>
              </div>
              <div className='mt-2 text-xs text-primary'>Add Scheme</div>
            </button>
          </div>
        </>
      )}
    </div>
  );
}
